import apiClient from "./apiInterceptor";

export const emailAIService = {
  generateEmailDraft: async (params) => {
    try {
      // Simulate API call for now since backend endpoint is pending
      // const response = await apiClient.post("/api/ai/generate-email", params);
      // return response.data;
      
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            subject: `${params.purpose} - ${params.productName}`,
            greeting: `Hello {{CustomerName}},`,
            body: `We are reaching out regarding ${params.productName}. Please let us know if you need any more information.\n\nBest regards,\nThe ENTELI-PRO Team`,
            cta: ``,
          });
        }, 1500);
      });
    } catch (error) {
      console.error("Error generating email draft:", error);
      throw error;
    }
  },

  improveEmail: async (content, action) => {
    try {
      // Simulate API call
      // const response = await apiClient.post("/api/ai/improve-email", { content, action });
      // return response.data;
      
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            content: `${content}`,
          });
        }, 1000);
      });
    } catch (error) {
      console.error(`Error improving email (${action}):`, error);
      throw error;
    }
  },

  sendBulkEmail: async (data) => {
    try {
      // Simulate API call
      // const response = await apiClient.post("/api/email/send-bulk", data);
      // return response.data;
      
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            success: true,
            message: `Successfully sent email to ${data.recipients.length} recipients.`,
          });
        }, 2000);
      });
    } catch (error) {
      console.error("Error sending bulk email:", error);
      throw error;
    }
  }
};
